export const API_URL = 'https://ext-chat-service-be-1004368012096.asia-south1.run.app/api'
export const SOCKET_URL = 'https://ext-chat-service-be-1004368012096.asia-south1.run.app'